import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
    const { user, login } = useAuth();
    const [email, setEmail] = useState("founder@sixthelement.in");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);
    const navigate = useNavigate();

    if (user) return <Navigate to="/" replace />;

    const onSubmit = async (e) => {
        e.preventDefault();
        setErr("");
        setBusy(true);
        const r = await login(email, password);
        setBusy(false);
        if (r.ok) navigate("/");
        else setErr(r.error || "Login failed");
    };

    return (
        <div className="min-h-screen grid md:grid-cols-2" data-testid="login-page">
            <div
                className="hidden md:block"
                style={{
                    backgroundImage:
                        "url(https://images.pexels.com/photos/13005858/pexels-photo-13005858.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1200)",
                    backgroundSize: "cover", backgroundPosition: "center",
                }}
            >
                <div className="h-full w-full flex flex-col justify-between p-10" style={{ background: "linear-gradient(180deg, rgba(28,25,23,0.15) 0%, rgba(28,25,23,0.55) 100%)" }}>
                    <div className="text-white font-serif text-3xl leading-tight max-w-md">
                        Every rupee, in and out.<br/>
                        Quietly balanced.
                    </div>
                    <div className="text-white/80 text-xs uppercase tracking-widest">
                        Sixth Element Furnishing Solutions Pvt Ltd · Bengaluru
                    </div>
                </div>
            </div>
            <div className="flex flex-col justify-center px-8 md:px-16 py-12 bg-white">
                <div className="max-w-sm w-full">
                    <div className="font-serif text-4xl tracking-tight mb-1">Sign in</div>
                    <div className="text-sm text-stone-500 mb-8">Access the ledgers for Jordyblue &amp; Unwind.</div>
                    <form onSubmit={onSubmit} className="space-y-5" data-testid="login-form">
                        <div>
                            <Label htmlFor="email" className="text-xs uppercase tracking-widest text-stone-500">Email</Label>
                            <Input id="email" data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" required />
                        </div>
                        <div>
                            <Label htmlFor="password" className="text-xs uppercase tracking-widest text-stone-500">Password</Label>
                            <Input id="password" data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" required />
                        </div>
                        {err ? <div className="text-sm p-2 rounded-sm" style={{ background: "var(--se-err-bg)", color: "var(--se-err-text)" }} data-testid="login-error">{err}</div> : null}
                        <Button type="submit" disabled={busy} data-testid="login-submit" className="w-full" style={{ background: "var(--se-brand)", color: "#fff" }}>
                            {busy ? "Signing in…" : "Sign in"}
                        </Button>
                    </form>
                </div>
            </div>
        </div>
    );
}
